/* src/app/views/excel-reports/reports/reports.component.scss */
.container-body {
  padding: 0 24px 24px;
}
.reports-form {
  width: 100%;
  padding: 0 18px;
  border-radius: 12px;
}
.product-itens {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(280px, 31.5%));
  justify-content: space-between;
  column-gap: 18px;
  row-gap: 12px;
  margin: 0;
}
.product-itens > .report-field,
.product-itens > .report-message {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
}
#countryNotBra,
.report-message {
  grid-column: 1/-1;
  align-self: start;
}
.report-field .element-edit,
.report-message .message-edit {
  width: 100%;
}
.element-edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #2f3b52;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
}
.element-edit-label {
  margin-bottom: 8px;
  color: #3f464d;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}
.space-second {
  margin-left: 0;
}
.message-edit {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 56px;
  padding: 14px 16px;
  border: 1px solid #f3d9a5;
  border-radius: 10px;
  background: #ffffff;
  color: #825c14;
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
}
.message-edit p {
  margin: 0;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
}
.message-edit .pi {
  font-size: 16px;
}
.showItems {
  display: block;
}
.hideItems {
  display: none;
}
.button-position {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  margin-top: 22px;
  padding-top: 18px;
  padding-bottom: 8px;
  border-top: 1px solid #d9d9d9;
  width: 100%;
}
.button-position > button,
.button-position .btn-pattern {
  width: 252px;
  min-width: 252px;
  height: 48px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-sizing: border-box;
}
.button-position .action-button-label {
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
:host ::ng-deep .reports-form .p-dropdown,
:host ::ng-deep .reports-form .ui-dropdown {
  border-radius: 12px;
  min-height: 56px;
}
:host ::ng-deep .reports-form .p-dropdown .p-dropdown-label,
:host ::ng-deep .reports-form .ui-dropdown .ui-dropdown-label {
  display: inline-flex;
  align-items: center;
  min-height: 56px;
  padding-left: 14px;
}
:host ::ng-deep .reports-form .p-dropdown .p-dropdown-trigger,
:host ::ng-deep .reports-form .ui-dropdown .ui-dropdown-trigger {
  min-height: 56px;
}
:host ::ng-deep .reports-form .p-dropdown:not(.p-disabled):hover,
:host ::ng-deep .reports-form .ui-dropdown:not(.ui-state-disabled):hover {
  border-color: #95b7e8;
  box-shadow: 0 0 0 2px rgba(4, 108, 234, 0.08);
}
:host ::ng-deep .reports-form .p-dropdown.p-focus,
:host ::ng-deep .reports-form .ui-dropdown.ui-state-focus {
  border-color: #046cea;
  box-shadow: 0 0 0 3px rgba(4, 108, 234, 0.15);
}
:host ::ng-deep .reports-form .client-data-message {
  margin-top: 6px;
}
@media only screen and (max-width: 900px) {
  .container-body {
    padding: 0 12px 14px;
  }
  .reports-form {
    padding: 0;
  }
  .product-itens {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 12px;
    row-gap: 10px;
  }
  #countryNotBra,
  .report-message {
    grid-column: span 2;
  }
  .element-edit {
    font-size: 15px;
    line-height: 20px;
  }
  .message-edit {
    min-height: 52px;
    font-size: 14px;
    line-height: 20px;
  }
  .button-position {
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 18px;
    padding-top: 14px;
    padding-bottom: 10px;
  }
  .button-position > button,
  .btn-pattern {
    width: auto;
    min-width: 190px;
    height: 44px;
  }
}
@media only screen and (max-width: 500px) {
  .container-body {
    padding: 0 12px 10px;
  }
  .product-itens {
    grid-template-columns: 1fr;
  }
  #countryNotBra,
  .report-message {
    grid-column: span 1;
  }
  .element-edit {
    font-size: 14px;
    line-height: 18px;
  }
  .element-edit-label {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 18px;
  }
  .message-edit {
    min-height: 48px;
    font-size: 13px;
    line-height: 18px;
    padding: 10px 12px;
  }
  .button-position {
    gap: 8px;
    margin-top: 10px;
    padding-top: 10px;
    padding-bottom: 4px;
  }
  .button-position > button,
  .btn-pattern {
    width: 100%;
    min-width: 0;
    height: 42px;
    font-size: 12pt;
  }
  :host ::ng-deep .reports-form .p-dropdown,
  :host ::ng-deep .reports-form .ui-dropdown,
  :host ::ng-deep .reports-form .p-dropdown .p-dropdown-label,
  :host ::ng-deep .reports-form .ui-dropdown .ui-dropdown-label,
  :host ::ng-deep .reports-form .p-dropdown .p-dropdown-trigger,
  :host ::ng-deep .reports-form .ui-dropdown .ui-dropdown-trigger {
    min-height: 50px;
  }
}
/*# sourceMappingURL=reports.component-FL5EQ3P4.css.map */
